import React from 'react';
import styled from 'styled-components';

const Vision = ({ landingPrimaryColor }) => {
  return (
    <section class="schedule" style={{ fontFamily: 'Poppins, sans-serif' }}>
      <div class="container">
        <div class="schedule-inner">
          <div class="row">
            <div class="col-lg-4 col-md-6 col-12 ">
              <div
                class="single-schedule first"
                style={{ background: landingPrimaryColor }}
              >
                <div class="inner">
                  <div class="icon">
                    <img src="img/misc/vision.png" />
                  </div>
                  <div class="single-content">
                    <h4>Vision</h4>
                    <p>
                      To be the trusted leader in providing seamless recharge
                      and utility bill payment services
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div
                class="single-schedule middle"
                style={{ backgroundColor: landingPrimaryColor }}
              >
                <div class="inner">
                  <div class="icon">
                    <img src="img/misc/mission.png" />
                  </div>
                  <div class="single-content">
                    <h4>Mission</h4>
                    <p>
                      To offer fast, secure, and cost-effective recharge
                      solutions that simplify the process for businesses and
                      customers
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-12">
              <div
                class="single-schedule last"
                style={{ backgroundColor: landingPrimaryColor }}
              >
                <div class="inner">
                  <div class="icon">
                    <i class="icofont-ui-clock"></i>
                  </div>
                  <div class="single-content">
                    <h4>Service</h4>
                    <p>
                      We provide services with a 99% success rate, ensuring
                      fast, reliable, and complaint-free experiences
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
